import React from 'react';
import Layout from '../components/Layout';
import AdminPanel from '../components/AdminPanel';

const Admin: React.FC = () => {
  return (
    <Layout>
      <AdminPanel />
    </Layout>
  );
};

export default Admin; 